export default __webpack_public_path__ + "static/nakahara_main-a9c45b8c434cab9b6b0dcc8a6c735148.jpg";